module.exports = __webpack_public_path__ + "img/hk.e0f4d834.jpg";